export default {
  namespaced: true,
  actions: {
    getOverview({ dispatch }, { countries = [], from = null, to = null }) {
      return dispatch(
        'app/makeCall',
        {
          route: 'overview.getOverview',
          payload: {
            countries: countries.map((i) => i.name),
            from,
            to
          }
        },
        { root: true }
      )
        .then((response) => {
          return response.data
        })
        .catch((err) => {
          throw err
        })
    },
    getCompetitions({ dispatch }, { page, status, limit, search, countries = [], from = null, to = null }) {
      const searchParams = {
        page: page || null,
        status: status || null,
        limit: limit || 20,
        search: search || null,
        countries: countries.map((i) => i.name),
        from,
        to
      }
      return dispatch(
        'app/makeCall',
        {
          route: 'overview.getCompetitions',
          payload: searchParams
        },
        { root: true }
      )
        .then((response) => {
          return response.data
        })
        .catch((err) => {
          throw err
        })
    },
    getPdf({ dispatch }, { countries = [], from = null, to = null } = {}) {
      const searchParams = {
        countries: countries.map((i) => i.name),
        from,
        to
      }
      return dispatch(
        'app/makeCall',
        {
          route: 'overview.getPdf',
          payload: searchParams
        },
        { root: true }
      ).catch((err) => {
        throw err
      })
    },
    getCsv({ dispatch }, { countries = [], from = null, to = null } = {}) {
      const searchParams = {
        countries: countries.map((i) => i.name),
        from,
        to
      }
      return dispatch(
        'app/makeCall',
        {
          route: 'overview.getCsv',
          payload: searchParams
        },
        { root: true }
      ).catch((err) => {
        throw err
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/overview.js